import { render } from "./EventInspectorView.vue?vue&type=template&id=f01b759e"
import script from "./EventInspectorView.vue?vue&type=script&lang=js"
export * from "./EventInspectorView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__